/* eslint-disable no-var, i18next/no-literal-string */
import { ImageConstantType } from 'common/ImageConstants';
import { ThemeType } from 'common/theme';

declare var __webpack_public_path__: string;
declare var __portal_assets_url__: string;

let localesPath = 'locales/{{lng}}/{{ns}}.json';
let assetsPath = 'assets/';
let portalAssetsUrl = '';

if (window && Object.prototype.hasOwnProperty.call(window, '__portal_assets_url__')) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  __webpack_public_path__ = __portal_assets_url__;
  localesPath = __portal_assets_url__ + localesPath;
  assetsPath = __portal_assets_url__ + assetsPath;
  portalAssetsUrl = __portal_assets_url__;
} else {
  // index.html was served by SPA middleware. This can happen if a request URL is not a registered route
  // Fix static asset paths to fetch resources from Portal directly
  localesPath = `/${localesPath}`;
  assetsPath = `/${assetsPath}`;
  portalAssetsUrl = '/';
}

// console.log("assets root path: " + __webpack_public_path__);

export function getLocalesPath(): string {
  return localesPath;
}

/**
 * Theme must be provided for themed images, otherwise the path will be incorrect.
 * @param imageName {ImageConstantType} Either a simple image name (no theme required) or an object with Light and Dark theme image names
 * @param theme Optional theme, which will determine which image to return
 * @returns {string} Image path
 */
export function getAssetPath(imageName: ImageConstantType, theme?: ThemeType): string {
  if (typeof imageName === 'object') {
    return theme === 'Dark' ? getAssetPath(imageName.Dark, theme) : getAssetPath(imageName.Light, theme);
  }

  return theme ? `${assetsPath}${theme}/${imageName}` : `${assetsPath}${imageName}`;
}

export function getPortalAssetsUrl(): string {
  return portalAssetsUrl;
}
